module.exports = __webpack_public_path__ + "img/product12.17c18f1f.jpg";